import { getDateByOffset } from '~/utils';

import { useCalendar } from '../common';

const useStorageCalendar = () => {
  // 보관비 조회 캘린더 최소 날짜
  const MIN_DATE = new Date(2025, 5, 1);

  // 보관비 조회 캘린더 최대 날짜
  const getMaxDate = () => {
    const today = new Date();

    if (
      today < MIN_DATE ||
      (today.getFullYear() === MIN_DATE.getFullYear() &&
        today.getMonth() === MIN_DATE.getMonth() &&
        today.getDate() === MIN_DATE.getDate())
    ) {
      return MIN_DATE;
    }
    if (today.getDate() === 1) {
      return getDateByOffset(-1, 'month');
    }
    return today;
  };

  const { currentDate, days, goToPrevMonth, goToNextMonth } = useCalendar({ initialDate: getMaxDate() });

  const isCalendarMonthEqualToMinDate =
    currentDate.getMonth() === MIN_DATE.getMonth() && currentDate.getFullYear() === MIN_DATE.getFullYear();

  const isCalendarMonthEqualToMaxDate =
    currentDate.getMonth() === getMaxDate().getMonth() && currentDate.getFullYear() === getMaxDate().getFullYear();

  return {
    currentDate,
    days,
    goToPrevMonth,
    goToNextMonth,
    isPrevMonthDisabled: isCalendarMonthEqualToMinDate,
    isNextMonthDisabled: isCalendarMonthEqualToMaxDate,
  };
};

export default useStorageCalendar;
